import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PermissionsListComponent } from './permissions-list/permissions-list.component';
import { PermissionsCreateComponent } from './permissions-create/permissions-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: PermissionsListComponent,
        data: {
          title: "Permissions List",
          breadcrumb: "Permissions List"
        }
      },
      {
        path: 'create',
        component: PermissionsCreateComponent,
        data: {
          title: "Create Permissions",
          breadcrumb: "Create Permissions"
        }
      },
      {
        path: 'edit/:id',
        component: PermissionsCreateComponent,
        data: {
          title: "Edit Permissions",
          breadcrumb: "Edit Permissions"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class PermissionsRoutingModule { }
